import React, { useCallback } from 'react';
import moment from 'moment';

import FileIcon from '../../assets/icons/FileIcon';

const LeadDocuments = (props) => {
  const { documents = [], onPreviewClick, users = [] } = props;

  const onFileClick = (url) => {
    window.open(url, '_blank');
  };

  const getUserName = useCallback((uid) => {
    const user = users.find((u) => u.uid === uid);
    return user ? `${user.firstName} ${user.lastName}` : '';
  }, [users]);

  return (
    <div className="lead-documents__container">
      {/*<div className="d-flex space-between p-t-md p-b-md p-l-lg p-r-md">*/}
      {/*  <div className="d-flex">*/}
      {/*    <DocumentsIcon />*/}
      {/*    <div className="m-l-md font-bold font-size-lg">*/}
      {/*      Documents*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*  <AddButton onClick={() => toggleModal(true)} />*/}
      {/*</div>*/}

      <div
        className="lead-documents-list__container"
        onClick={onPreviewClick}
      >
        {documents?.length ? (
          documents.map((document) => (
            <div key={document.id} className="lead-document" onClick={() => onFileClick(document.downloadUrl)}>
              <div className="d-flex space-between">
                <div className='font-bold'>{getUserName(document.userId)}</div>
                <div className='secondary font-size-sm'>{document.createdAt ? moment(document.createdAt).fromNow() : ''}</div>
              </div>
              <div className='m-t-md d-flex space-between'>
                <div className="d-flex">
                  <FileIcon className="m-r-md" color="var(--app-text)" />
                  {document.fileName}
                </div>
                {/*<IconButton*/}
                {/*  onClick={() => onDelete(document.id)}*/}
                {/*  size="small"*/}
                {/*>*/}
                {/*  <DeleteOutlineIcon fontSize='small' color="#F53434" />*/}
                {/*</IconButton>*/}
              </div>
            </div>
          ))
        ) : (
          <div className="p-lg font-size-bg font-bold secondary d-flex flex-center">
            No Documents
          </div>
        )}
      </div>
    </div>
  );
};

export default LeadDocuments;
